<non-admin-lock-panel></non-admin-lock-panel>

<div *ngIf="sharedDatasSvc.isAdmin" class="card mt-3 shadow-sm">
    <div class="card-header text-center d-flex align-items-center">
        <h3 class="flex-fill" paflabel="Liste_des_comptes_utilisateurs"></h3>
        <button class="btn btn-primary btn-sm mx-1" (click)="reloadAll()"><i class="fas fa-sync"></i></button>
        <button class="btn btn-sm btn-success mx-1" type="button" (click)="excelExport.save()"
            [disabled]="extUsers.length==0"><i class="far fa-file-excel mr-1"></i>Exporter</button>
    </div>
    <div class="card-body">
        <kendo-grid 
            [data]="gridData" 
            [pageSize]="state.take" 
            [skip]="state.skip" 
            [sort]="state.sort"
            [filter]="state.filter" 
            [sortable]="true" 
            [pageable]="{pageSizes: [10,20,50,100]}" 
            [filterable]="'menu'"
            (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column *ngIf="sharedDatasSvc.debug" field="Id" title="Id"></kendo-grid-column>
            <kendo-grid-column field="StatusId" title="Statut" [width]="150">
                <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
                    let-filterService="filterService">
                    <div style="width:100%;">
                        <kendo-multiselect class="filter-multi-select form-control" name="filterStatuts"
                            [data]="lstStatuts" textField="traduction" valueField="Id" [valuePrimitive]="true"
                            [value]="state.filter | filterValues"
                            (valueChange)="gridFiltersChange($event, filterService,column)">
                        </kendo-multiselect>
                    </div>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="d-flex justify-content-end align-items-center">
                        <div class="mr-auto">{{dataItem.StatutLib}}</div>
                        <button *ngIf="dataItem.StatusId!=3" class=" ml-2 btn btn-xs btn-warning"
                            (click)="resetPwd(dataItem)" style="min-width: 35px;"><i class="fas fa-key"></i><i
                                class="fas fa-redo"></i></button>
                        <button *ngIf="dataItem.StatusId==2 || dataItem.StatusId==3"
                            class=" ml-2 btn btn-xs btn-primary" (click)="resetPwd(dataItem)"><i
                                class="fas fa-user-check"></i></button>
                        <button *ngIf="dataItem.StatusId!=3" class=" ml-2 btn btn-xs btn-danger"
                            (click)="lockUser(dataItem)"><i class="fas fa-user-lock"></i></button>
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Email" title="Email"></kendo-grid-column>
            <kendo-grid-column field="LastName" title="Nom"></kendo-grid-column>
            <kendo-grid-column field="FirstName" title="Prénom"></kendo-grid-column>
            <kendo-grid-column field="Phone" [width]="120" title="Téléphone"></kendo-grid-column>
            <kendo-grid-column field="SupplierStatutLib" title="Statut du fournisseur"></kendo-grid-column>
            <kendo-grid-column field="SupplierName" [width]="400" title="Nom du fournisseur">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" let-column="column">
                    <a class="control-label" [routerLink]="getSupplierLink(dataItem)" [paftooltip]="'Fiche_fournisseur'" target="_blank">
                    {{ dataItem.SupplierName }}
                    </a>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="NumTiers" [width]="100" title="Tiers"></kendo-grid-column>
            <kendo-grid-column field="UniqueId" [width]="160" title="N° Identifiant"></kendo-grid-column>
            <kendo-grid-column field="InternalDemandDate" class="text-center" title="Date de demande"  [format]="{ datetime: 'short' }" [autoSize]="true" filter="date"></kendo-grid-column>            
        </kendo-grid>
        <kendo-excelexport [fileName]="excelFilename" [data]="extUsers" [filterable]="true" #excelExport>
            <kendo-excelexport-column field="StatutLib" title="Statut"></kendo-excelexport-column>
            <kendo-excelexport-column field="SupplierStatutLib" title="Statut du fournisseur"></kendo-excelexport-column>
            <kendo-excelexport-column field="SupplierName" title="Nom du fournisseur"></kendo-excelexport-column>
            <kendo-excelexport-column field="NumTiers" title="Tiers"></kendo-excelexport-column>
            <kendo-excelexport-column field="UniqueId" title="N° identification"></kendo-excelexport-column>
            <kendo-excelexport-column field="Email" title="Email"></kendo-excelexport-column>
            <kendo-excelexport-column field="LastName" title="Nom"></kendo-excelexport-column>
            <kendo-excelexport-column field="FirstName" title="Prénom"></kendo-excelexport-column>
            <kendo-excelexport-column field="InternalDemandDate" title="Date de demande"></kendo-excelexport-column>
        </kendo-excelexport>
    </div>
</div>

<PRE *ngIf="sharedDatasSvc.debug">
    lstStatuts: {{lstStatuts | json}}

    extUsers:{{extUsers | json}}
</PRE>